import { TUseTableRelationshipsQuery } from '../../drivers';

export const useTableRelationshipsQuery: TUseTableRelationshipsQuery = () => {
  throw new Error('not implemented for mssql');
};
